import 'jquery-bar-rating';

const initRating = ($node) => {
  $node.barrating({
    theme: 'css-stars',
    allowEmpty: true,
    emptyValue: '0',
    deselectable: true,
  });
};

export { initRating };
